import { AppEnvironment } from '../environment'
import { configuratorInterface } from '../systems/configurator-interface'

export const appEnvironmentElement = configuratorInterface.createCustomPhoenixLayoutElement(
  'AppEnvironment',
  AppEnvironment
)
